var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_conditions",
    transform: "translate(-272 -58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48774",
    "data-name": "Path 48774",
    d: "M386.29,556.682a.968.968,0,0,1-.687.284h-4.059v4.059a.971.971,0,1,1-1.942,0v-4.059h-4.059a.971.971,0,0,1,0-1.941H379.6v-4.059a.971.971,0,0,1,1.941,0v4.059H385.6a.971.971,0,0,1,.687,1.657Z",
    transform: "translate(-96.574 -485.996)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_add.dfc0cc3e89972f3f94f34a8fb975eac9.svg";